import { QueryFactory } from "../../../../Common";
import { Search } from "../../../../Contracts";
export const QPersonalizedEvents = QueryFactory(Search.QueryTypes.PersonalizedEvents);
//# sourceMappingURL=QPersonalizedEvents.js.map